import type { IconProps } from '../types/IconProps.ts';
export const SquareArrowOutUpRight: IconProps = {
    name: 'SquareArrowOutUpRight',
    children: [
        `<path d="M21 13v7.5a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-17c0-.28.22-.5.5-.5H11M15 3h5.5c.28 0 .5.22.5.5V9M12 12l8-8" />`,
    ]
};